function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.71778 7.54053H3.98305C3.86587 7.54053 3.76953 7.6665 3.76953 7.82123C3.76953 7.97596 3.86639 8.10193 3.98305 8.10193H9.71778C9.836 8.10193 9.9313 7.97596 9.9313 7.82123C9.9313 7.6665 9.836 7.54053 9.71778 7.54053Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5889 5.65308H4.04828C3.89287 5.65308 3.76758 5.77905 3.76758 5.93378C3.76758 6.08851 3.89355 6.21448 4.04828 6.21448H11.5889C11.7443 6.21448 11.8696 6.08851 11.8696 5.93378C11.8696 5.77905 11.7443 5.65308 11.5889 5.65308Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5895 3.77026H4.05023C3.89619 3.77026 3.76953 3.89624 3.76953 4.05028C3.76953 4.20501 3.89687 4.33098 4.05023 4.33098H11.5895C11.7449 4.33098 11.8702 4.20501 11.8702 4.05028C11.8702 3.89624 11.7449 3.77026 11.5895 3.77026Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.4165 0H1.22345C0.548397 0 0 0.549767 0 1.22345V10.6469C0 11.3082 0.529228 11.8484 1.18443 11.8689C1.19812 11.8703 1.21113 11.8724 1.22345 11.8724H8.64633L12.3318 15.5578C12.3865 15.6112 12.4591 15.6399 12.5324 15.6399C12.5673 15.6399 12.6042 15.6338 12.6392 15.618C12.7432 15.5756 12.8131 15.4729 12.8131 15.3592V11.8724H14.4165C14.4309 11.8724 14.4432 11.871 14.4569 11.8689C15.1093 11.8477 15.6379 11.3103 15.6406 10.6441V1.22072C15.6372 0.547028 15.0881 0 14.4165 0ZM15.0785 10.6489C15.0772 11.0118 14.7787 11.3075 14.4165 11.3075C14.4042 11.3075 14.3925 11.3089 14.3816 11.3096H12.5324C12.3756 11.3096 12.2517 11.4356 12.2517 11.591V14.6814L8.96058 11.3924C8.90718 11.3397 8.83735 11.3096 8.76272 11.3096H1.25837C1.24468 11.3089 1.23578 11.3075 1.22345 11.3075C0.85854 11.3075 0.561406 11.0104 0.561406 10.6462V1.22277C0.561406 0.857855 0.85854 0.560721 1.22345 0.560721H14.4165C14.7787 0.560721 15.0772 0.857855 15.0785 1.22482V10.6489Z",
  fill: "currentColor"
});

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.f6976018.svg";
export { ForwardRef as ReactComponent };